import { render, staticRenderFns } from "./downHint.vue?vue&type=template&id=048f8db0&"
import script from "./downHint.vue?vue&type=script&lang=js&"
export * from "./downHint.vue?vue&type=script&lang=js&"
import style0 from "./downHint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports